import { ColumnSelectionItem } from '../components/templates/ColumnSelection';

/** Fields currently ticked in a ColumnSelection tree. */
export const getVisibleFields = (data: ColumnSelectionItem[]): Set<string> => {
  const fields = new Set<string>();
  for (const group of data) {
    for (const col of group.value) {
      if (col.value) fields.add(col.field);
    }
  }
  return fields;
};

export const getSelectedColumnNames = (
  columnSelectionItems?: ColumnSelectionItem[],
  defaultExcludedColumns?: string[]
) => {
  // Clone so we don't mutate the caller's array. Several pages pass a
  // module-level constant here (see constants/clientContract.ts), and a
  // previous version pushed onto that array directly, growing the
  // exclude list every refetch.
  const excludedColumns: string[] = defaultExcludedColumns ? [...defaultExcludedColumns] : [];

  if (columnSelectionItems) {
    columnSelectionItems.forEach((item) => {
      return item.value.forEach((valueItem) => {
        if (!valueItem.value) {
          excludedColumns.push(valueItem.field);
        }
      });
    });
  }

  const index = excludedColumns.indexOf('id');
  if (index > -1) {
    excludedColumns.splice(index, 1);
  }

  return excludedColumns.toString();
};
